export const merchantCategories: {
  value: string;
  displayText: string;
}[] = [
  {
    displayText: 'Video Games',
    value: 'Video Games'
  },
  {
    displayText: 'Traditional Chipper',
    value: 'Traditional Chipper'
  },
  {
    displayText: 'Street food',
    value: 'Street food'
  },
  {
    displayText: 'Pizza',
    value: 'Pizza'
  },
  {
    displayText: 'Pharmacy',
    value: 'Pharmacy'
  },
  {
    displayText: 'Pet supplies',
    value: 'Pet supplies'
  },
  {
    displayText: 'Mexican food',
    value: 'Mexican food'
  },
  {
    displayText: 'Iced drinks',
    value: 'Iced drinks'
  },
  {
    displayText: 'Ice cream',
    value: 'Ice cream'
  },
  {
    displayText: 'Groceries',
    value: 'Groceries'
  },
  {
    displayText: 'Fast Food',
    value: 'Fast Food'
  },
  {
    displayText: 'Drinks',
    value: 'Drinks'
  },
  {
    displayText: 'Dessert',
    value: 'Dessert'
  },
  {
    displayText: 'Dairy',
    value: 'Dairy'
  },
  {
    displayText: 'Coffee',
    value: 'Coffee'
  },
  {
    displayText: 'Chicken wings',
    value: 'Chicken wings'
  },
  {
    displayText: 'Chicken burgers',
    value: 'Chicken burgers'
  },
  {
    displayText: 'Cafe',
    value: 'Cafe'
  },
  {
    displayText: 'Book store',
    value: 'Book store'
  },
  {
    displayText: 'Chinese Food',
    value: 'Chinese Food'
  },
  {
    displayText: 'American Food',
    value: 'American Food'
  },
  {
    displayText: 'Burgers',
    value: 'Burgers'
  },
  {
    displayText: 'Hot dogs',
    value: 'Hot dogs'
  },
  {
    displayText: 'Indian Food',
    value: 'Indian Food'
  },
].sort((a, b) => a.displayText.localeCompare(b.displayText));
